import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, ref, watch } from 'vue';
import store from '@/store/index';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
// import zhCn from 'element-plus/es/locale/lang/zh-cn';
import zhHK from 'element-plus/es/locale/lang/zh-tw';
import en from 'element-plus/es/locale/lang/en';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const locale = ref(zhHK);
nextTick(() => {
  switch(store.getters.getLanguageValue) {
    case 'en':
      locale.value = en
      break;
    case 'zh-hk':
      locale.value = zhHK
      break;
    case 'zh-cn':
      locale.value = zhCn
      break;
    default:
      locale.value = zhHK
  } 
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: locale.value }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})